import { cva } from "class-variance-authority";

/**
 * `centered` is the page/section empty state — a large block that owns its container.
 * `inline` is the compact in-card variant: a bordered strip that explains why a panel has no data
 * without taking over the card it sits in.
 */
export const emptyStateVariants = cva("flex", {
  variants: {
    layout: {
      centered: "flex-col items-center justify-center gap-4 p-10",
      inline: "items-start gap-3 rounded-lg border p-3",
    },
  },
  defaultVariants: { layout: "centered" },
});

export const emptyStateIconWrapperVariants = cva(
  "flex items-center justify-center rounded-full",
  {
    variants: {
      layout: {
        centered: "size-12 bg-muted/20",
        inline: "size-8 shrink-0 bg-muted",
      },
    },
    defaultVariants: { layout: "centered" },
  },
);

export const emptyStateIconVariants = cva("text-muted-foreground", {
  variants: {
    layout: {
      centered: "size-6",
      inline: "size-4",
    },
  },
  defaultVariants: { layout: "centered" },
});

export const emptyStateBodyVariants = cva("", {
  variants: {
    layout: {
      centered: "space-y-2 text-center",
      inline: "min-w-0",
    },
  },
  defaultVariants: { layout: "centered" },
});

export const emptyStateTitleVariants = cva("text-sm", {
  variants: {
    layout: {
      centered: "font-medium text-foreground",
      inline: "font-semibold",
    },
  },
  defaultVariants: { layout: "centered" },
});

export const emptyStateDescriptionVariants = cva("text-muted-foreground", {
  variants: {
    layout: {
      centered: "text-sm",
      inline: "mt-0.5 text-xs",
    },
  },
  defaultVariants: { layout: "centered" },
});
